module.exports = __webpack_public_path__ + "resources/img/img_intro_certi4.20209e06d500a9b9e363e93c0a4a6d02.png";